<template>
  <div class="mx-auto w-full max-w-(--breakpoint-xl)">
    <div class="mx-2 md:mx-5">
      <slot />
    </div>
  </div>
</template>
